import styled from 'styled-components';
import SearchInput from '../../../features/landingPage/components/SearchInput';

const StyledSearchInput = styled(SearchInput)`
  &.form-control {
    font-family: ${({ theme }) => theme.fontFamily};
    padding: ${({ size, padding }) =>
      padding
        ? padding
        : size === 'small'
        ? '3px 45px 6px 8px'
        : '6px 40px 10px 20px'};
    font-size: ${({ size , responsive}) => responsive ? 'clamp(16px, 2vw, 20px)' :  (size === 'small' ? '14px' : '18px')};
    border-radius: ${({ size }) => (size === 'small' ? '4px' : '8px')};
    height: ${({ size }) =>
      size === 'product' ? '44px' : size === 'small' ? '32px' : '48px'};
    border: 1.5px solid
      ${({ theme, stroke }) => (stroke ? stroke : theme.lightGray1)};
    line-height: ${({ size }) => (size === 'small' ? 'normal' : 'unset')};
    text-overflow: ellipsis;
    &::-webkit-input-placeholder {
    padding : 0px;
      font-family: ${({ theme }) => theme.fontFamily};
      color: ${({ theme, $phColor }) =>
        $phColor ? theme[$phColor] : theme.placeholder};
      font-size: ${({ size , responsive , $phFontSize }) => $phFontSize ? $phFontSize : responsive ? 'clamp(16px, 2vw, 20px)' :  (size === 'small' ? '14px' : '18px')};
    }
    background-color: ${({ $bgColor }) => $bgColor || 'transparent'};
  }
  svg {
    display: none !important;
    color: ${({ theme, $iconColor }) =>
      $iconColor ? theme[$iconColor] : theme.primary}!important;
   height: ${({ svgSize }) => (svgSize ? svgSize : '20px')};
   width: ${({ svgSize }) => (svgSize ? svgSize : '20px')};
  }
`;

export default StyledSearchInput;
